import { useQuery } from "@tanstack/react-query";
import { rmTypApi } from "components/api/comm";
import Select, { SelectProps } from "components/select";
import { IRmComm, ISelect } from "interface";
import { useRef } from "react";
import useAuthStore from "store/auth";

interface IProps extends Omit<SelectProps, "options"> {
  isReset?: boolean;
  select?(inf: any): void;
}

export default function RmTypCdSelect({
  defaultValue,
  isReset,
  dataTyp,
  isUpdateAble,

  select,
}: IProps) {
  const isLogin = useAuthStore((state) => state.isLogin);
  const rmTypRef = useRef<ISelect[]>([]);
  useQuery({
    queryKey: ["rmTypList"],
    queryFn: () => {
      return rmTypApi();
    },
    enabled: isLogin,
    select: (data) => {
      if (data) {
        rmTypRef.current = data.data?.cdList.map((typ: IRmComm) => {
          return {
            ko: typ.langCd === "ko" ? typ.codNm : "",
            en: typ.langCd === "en" ? typ.codNm : "",
            value: typ.lodCd,
            code: typ.lodCd,
          };
        });
      }
    },
  });

  return (
    <>
      <Select
        styles="bg-white border-1"
        name={"rmTypCd"}
        dataTyp={dataTyp}
        defaultValue={defaultValue}
        options={rmTypRef.current}
        isUpdateAble={isUpdateAble}
        validateTxt="객실타입을 선택하여 주세요."
        isReset={isReset}
        onSelect={(option) => {
          select && select(option?.code);
        }}
      />
    </>
  );
}
